import { z } from "zod";
import { Color } from "../shared/colors";
import { BaseOverlayConfig } from "../shared/config";
import { defineOverlay } from "../shared/functions";
const types = ["rounded", "slanted"];
const timerOptions = ["0", "5", "10", "15"];
const backgroundColors = [
    Color.DEFAULT_RED,
    Color.LIGHT_PURPLE,
    Color.DARK_PURPLE,
    Color.LIGHT_BLUE,
    Color.DARK_BLUE,
    Color.DARK_AQUA,
    Color.DARK_GREEN,
    Color.LIGHT_YELLOW,
    Color.DARK_YELLOW,
    Color.DARK_GREY,
];
export const MilestoneOverlay = defineOverlay({
    defaults: {
        backgroundColor: Color.DEFAULT_RED,
        displayTimer: "0",
        type: "rounded",
    },
    details: {
        category: "overlays",
        description: "Utilize our dynamic Milestone overlay to enhance your Tiltify fundraising campaign. Clearly display your next milestone as well as future ones on your stream.",
        features: [
            "Fits well into any streaming layouts",
            "Easily displays your active milestone",
            "Choose to show all milestones or rotate them in and out",
            "Displays which milestones have been completed",
        ],
        flags: {
            isFeatured: false,
            isNew: false,
            isUpdated: false,
            isVisible: true,
        },
        icon: "overlays/milestones.png",
        name: "Milestone Overlay",
        path: "/overlays/milestone",
        shortDescription: "Clearly display your next milestone as well as future ones on your stream.",
        slug: "milestones",
    },
    schema: BaseOverlayConfig.extend({
        backgroundColor: z
            .enum(backgroundColors)
            .default(() => MilestoneOverlay._config.defaults.backgroundColor)
            .optional(),
        displayTimer: z
            .enum(timerOptions)
            .default(() => MilestoneOverlay._config.defaults.displayTimer)
            .optional(),
        type: z
            .enum(types)
            .default(() => MilestoneOverlay._config.defaults.type)
            .optional(),
    }),
});
//# sourceMappingURL=milestone.js.map